import { productPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";

productPartNumbersStyles.erpNumberLabelText = {
  weight: "normal"
}

productPartNumbersStyles.erpNumberValueText = {
  weight: "bold"
}

// // EC-234 : SubTask - EC-282 = Updated style for Guest RFQ

productPartNumbersStyles.manufacturerItemLabelText = {
  weight: "normal"
}

productPartNumbersStyles.manufacturerItemValueText = {
  weight: "bold"
}

// // EC-234 : SubTask - EC-282 = Updated style for Guest RFQ